import React from 'react';
import { Input, Row, Col } from 'antd';

const AreasSearch = ({ areasData, searchText, setSearchText, setFilteredData }) => {
  const handleSearch = (value) => {
    const normalizedValue = value.toLowerCase().trim();
    setSearchText(value);

    if (!normalizedValue) {
      setFilteredData(areasData);
      return;
    }

    const filtered = areasData.filter((record) => {
      const name = record.name?.toLowerCase() || '';
      const deleteInfo = record.delete_info || {};

      const matchesName = name.includes(normalizedValue);
      const matchesAssets = String(deleteInfo.assets || '').includes(normalizedValue);
      const matchesControls = String(deleteInfo.controls || '').includes(normalizedValue);
      const matchesTasks = String(deleteInfo.tasks || '').includes(normalizedValue);
      const matchesUsers = String(deleteInfo.users || '').includes(normalizedValue);

      return (
        matchesName ||
        matchesAssets ||
        matchesControls ||
        matchesTasks ||
        matchesUsers
      );
    });

    setFilteredData(filtered);
  };

  const handleReset = () => {
    setSearchText('');
    setFilteredData(areasData);
  };

  return (
    <Row justify="start" style={{ marginBottom: 16 }}>
      <Col>
        <Input.Search
          className="search-table"
          placeholder="Buscar Áreas"
          value={searchText}
          onChange={(e) => handleSearch(e.target.value)}
          onSearch={handleSearch}
          allowClear
        />
      </Col>
    </Row>
  );
};

export default AreasSearch;